// Library
import React from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";

// Image
import completeIcon from "./images/complete.svg";

const bem = new BemHelper("step-indicator");

type Props = {
  title: string;
  step: number;
  complete: boolean;
  focus: boolean;
};

export const StepIndicator: React.FC<Props> = ({ title, step, complete, focus }) => {
  return (
    <div className={classNames(bem.block())}>
      <div
        className={classNames([bem.element("wrapper"), focus && bem.modifier("active", "wrapper")])}
      >
        {complete ? (
          <img src={completeIcon} />
        ) : (
          <div className={classNames(bem.element("indicator"))}>{step + 1}</div>
        )}
        <div className={classNames(bem.element("title"))}>{title}</div>
      </div>
    </div>
  );
};
